import { render } from "./template_mail.vue?vue&type=template&id=67b9f95c&scoped=true"
import script from "./template_mail.vue?vue&type=script&lang=js"
export * from "./template_mail.vue?vue&type=script&lang=js"

import "./template_mail.vue?vue&type=style&index=0&id=67b9f95c&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b9f95c"]])

export default __exports__